<template>
  <div class="redirect-wrap">Opening purchase return...</div>
</template>

<script>
export default {
  name: "editpurchasereturn",
  created() {
    this.$router.replace({
      path: "/createpurchasereturn",
      query: { ...this.$route.query },
    });
  },
};
</script>

<style scoped>
.redirect-wrap {
  padding: 24px;
  color: #6b7280;
}
</style>
